var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfigurationManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1240.562 3219.394 80 99.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a8a8a8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "configuration_management",
    "data-name": "configuration management",
    transform: "translate(1240.562 3219.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    className: "cls-1",
    d: "M127.647,45.644l-.033-29.005a3.336,3.336,0,0,0-2.19-3.128L88.819.2a3.343,3.343,0,0,0-2.276,0L49.937,13.511a3.336,3.336,0,0,0-2.19,3.128l-.033,29.005c-.226,23.754-.386,40.912,38.915,54.017a3.281,3.281,0,0,0,2.1,0C128.027,86.563,127.874,69.4,127.647,45.644ZM87.681,92.992C54.03,81.518,54.15,68.732,54.369,45.711L54.4,18.968l33.278-12.1,33.278,12.1.033,26.742C121.211,68.732,121.331,81.518,87.681,92.992Z",
    transform: "translate(-47.68 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    className: "cls-1",
    d: "M189.311,96a13.311,13.311,0,1,0,13.311,13.311A13.325,13.325,0,0,0,189.311,96Zm0,19.967a6.656,6.656,0,1,1,6.656-6.656A6.662,6.662,0,0,1,189.311,115.967Z",
    transform: "translate(-149.311 -76.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    className: "cls-1",
    d: "M167.295,256h-6.656A16.658,16.658,0,0,0,144,272.639a3.329,3.329,0,0,0,3.328,3.328h33.278a3.329,3.329,0,0,0,3.328-3.328A16.658,16.658,0,0,0,167.295,256Zm-16.067,13.311a10,10,0,0,1,9.411-6.655h6.656a10,10,0,0,1,9.411,6.655Z",
    transform: "translate(-123.967 -202.755)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurationManagement);
export default __webpack_public_path__ + "static/media/configuration-management.4215caa53552d8163d723dcd3cca5c64.svg";
export { ForwardRef as ReactComponent };